export default {"src":"/_next/static/media/search.eb916459.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};